"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileImageInput = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var themes_1 = require("../../../../themes");
var getVal_1 = require("../../../../utils/getterSetterDeleter/getVal");
var makeArrayFromLength_1 = require("../../../../utils/makeArrayFromLength");
var Typo_1 = require("../../../Typo");
var ProfileImageInput = function (_a) {
    var _b;
    var 
    //props that pass on to ImageInput
    id = _a.id, value = _a.value, onChange = _a.onChange, readOnly = _a.readOnly, invert = _a.invert, _c = _a.allowedFormats, allowedFormats = _c === void 0 ? ["jpg", "jpeg", "png"] : _c, disableImageBorder = _a.disableImageBorder, _d = _a.defaultImageSpread, defaultImageSpread = _d === void 0 ? "cover" : _d, _e = _a.containerShape, containerShape = _e === void 0 ? "circle" : _e, 
    //ProfileImageInput specific props
    _f = _a.size, 
    //ProfileImageInput specific props
    size = _f === void 0 ? 200 : _f, // Number > representing pixels
    _imageTitle = _a.imageTitle, imageTitlePath = _a.imageTitlePath, _content = _a.content;
    var content = _content;
    var imageTitle = _imageTitle ||
        (imageTitlePath && (0, getVal_1.getVal)(content, imageTitlePath)) ||
        (value && ((_b = value[0]) === null || _b === void 0 ? void 0 : _b.publicUrl)) ||
        "";
    var sizeString = size + "px";
    var calcPlaceholderInitialSize = function (_size) {
        var size = _size / 10; //cuz now we are using pixel size
        if (typeof size !== "number")
            return undefined;
        var inverseDecay = function (size) { return (1.2 / (size * size)) * 7; };
        var textSize = 0;
        (0, makeArrayFromLength_1.makeArrayFromLength)(size).map(function (s) {
            textSize = textSize + inverseDecay(s + 1);
        });
        return textSize + size / 2;
    };
    return (react_1.default.createElement("div", { style: { width: sizeString, height: sizeString } }, 
    //if edit mode then show imageinput
    //if readonly mode, then value has to exist for imageinput to show
    //the Array check is important so that string do that get accepted as value
    ((Array.isArray(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) || !readOnly) ? (react_1.default.createElement(__1.ImageInput, { id: id, value: value, onChange: onChange, aspectRatio: "1/1", containerShape: containerShape, enableCaptions: false, defaultImageSpread: defaultImageSpread, formatConvertConfig: "noConversion", omitEditorTools: ['cover_contain'], allowedFormats: allowedFormats, readOnly: readOnly, invert: invert, disableImageBorder: disableImageBorder })) : (react_1.default.createElement("div", { style: {
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: invert ? themes_1.colors.greyColor80 : themes_1.colors.greyColor100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        } },
        react_1.default.createElement(Typo_1.LABEL, { style: {
                fontSize: calcPlaceholderInitialSize(size),
                fontWeight: 500,
                letterSpacing: 0,
            }, invert: true }, imageTitle.charAt(0).toUpperCase())))));
};
exports.ProfileImageInput = ProfileImageInput;
